import { Close } from "@mui/icons-material";
import {
    DialogContent,
    Divider,
    DialogTitle,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Box,
} from "@mui/material";
import CustomDialog from "components/reusables/CustomDialog";

import React, { useState } from 'react'

const DialogBox = (props) => {

    let modelOpen = false

    const [_, forceUpdate] = useState({})
    const render = () => forceUpdate({})
    const {
        wrapperSupport = 'off',
        data = [],
        state = false,
        hanldeToggle = () => { },
        hanldeNo = () => { },
        handleYes = () => { },
        getStatus = () => { }
    } = props

    if (wrapperSupport === 'on') {
        props.helper.reRender = render
        modelOpen = getStatus()
    }

    const yesHandler = () => {
        if (wrapperSupport === 'on') {
            modelOpen = getStatus()
        }
        handleYes()
    }

    const noHandler = () => {
        if (wrapperSupport === 'on') {
            modelOpen = getStatus()
        }
        hanldeNo()
    }


    return (
        <CustomDialog onClose={() => hanldeToggle(isOpen)} open={wrapperSupport === "on" ? modelOpen : state}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <DialogTitle>Do you want to keep the same changes for all below formats?</DialogTitle>
                <IconButton
                    onClick={noHandler}
                    color="error"
                    sx={{
                        mr: '20px'
                    }}
                >
                    <Close />
                </IconButton>
            </Box>
            <Divider />
            <DialogContent>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 'none',
                        border: '1px solid #21212170'
                    }}
                >
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Procedure Name</strong></TableCell>
                                <TableCell><strong>Format Name</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.parentId}</TableCell>
                                    <TableCell>{item.documents}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2.5 }}>
                {/* <Button variant="contained" color="error" onClick={() => hanldeNo()}>
                    No
                </Button> */}
                <Button variant="contained" color="success"
                    // onClick={handleYes}
                    onClick={yesHandler}
                >
                    Yes
                </Button>
            </DialogActions>
        </CustomDialog>
    )
}

export default DialogBox
